import * as Yup from "yup";

export default Yup.object().shape({
  campaignId: Yup.string().required("Veuillez sélectionner le client"),

  docReq: Yup.string().nullable().notRequired(),

  docExpert: Yup.string().nullable().notRequired(),

  eventDate: Yup.date()
    .nullable()
    .typeError("Veuillez sélectionner une date valide")
    .required("Veuillez sélectionner la date"),

  lieu: Yup.string().required("Veuillez saisir le lieu"),

  numeroFacture: Yup.string().nullable().notRequired(),

  dateFacture: Yup.date().nullable().notRequired(),

  tarif: Yup.number()
    .typeError("Veuillez saisir un tarif valide")
    .min(0, "Le tarif doit être positif")
    .nullable()
    .notRequired(),  
});
